import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

let store = new Vuex.Store({
    state: {
        schema: {},
        formData: {},
        context: {
            response: {},
            currentPage: 0,
            totalPages: 0,
            formPages: {},
            validationErrors: [],
            variables: {},
            configuration: {},
            observability: {},
            faqs: {},
        }
    },
    mutations: {
        setSchema(currentState, f) {
            Vue.set(currentState, 'schema', f);
        },
        setFormData(currentState, f) {
            f = f || {}
            f.lastUpdate = new Date().getTime()
            Vue.set(currentState, 'formData', f);
            // window.console.log('setFormData>', currentState)
        },
        setConfiguration(currentState, f) {
            f.lastUpdate = new Date().getTime()
            Vue.set(currentState.context, 'configuration', f);
            // window.console.log('store::setConfiguration>', currentState, f)
        },
        setObservability(currentState, f) {
            Vue.set(currentState.context, 'observability', f);
        },
        set(currentState, keyValue) {
            Vue.set(currentState.formData, keyValue.key, keyValue.value);
            if (keyValue.value == null || keyValue === undefined) delete currentState.formData[keyValue.key]
        },
        setVariable(currentState, keyValue) {
            Vue.set(currentState.context.variables, keyValue.key, keyValue.value);
        },
        setCurrentPage(currentState, value) {
            // window.console.log('store::setCurrentPage>', value)
            Vue.set(currentState.context, 'currentPage', value);
        },
        addValidationError(currentState, value) {
            // window.console.log('store::addValidationError>', value)
            currentState.context.validationErrors.push(value)
        },
        clearValidationErrors(currentState) {
            // window.console.log('store::clearValidationErrors')
            let arr = currentState.context.validationErrors;
            arr.splice(0, arr.length);
        },
        setResponse(currentState, value) {
            Vue.set(currentState.context, 'response', value);
        }
    }
});

export default store;

